var map = {
	"./0.jpg": "5125",
	"./1.jpg": "98a8",
	"./2.jpg": "593c",
	"./3.jpg": "6800",
	"./ActivateCard.jpg": "90a8",
	"./BuyCard.jpg": "af64",
	"./ScanTicket.jpg": "4883",
	"./ScenicIndex.jpg": "978b",
	"./banner.jpg": "301c7",
	"./chicken.jpg": "57fb",
	"./code.jpg": "2171",
	"./follow.jpg": "0e9e",
	"./hb.jpg": "db54",
	"./mrtx.jpg": "e188",
	"./pay.jpg": "3f2b",
	"./vip.jpg": "66d5",
	"./yhj.jpg": "7367"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";